"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_RECOMMENDED_PRODUCTS = void 0;
exports.GET_RECOMMENDED_PRODUCTS = `
  {
    getRecommendedProducts
  }
`;
//# sourceMappingURL=recommended-products-queries.js.map